import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';
import GridText from 'components/text/GridText';

import { ENTER, SPACE, TEST_ID } from './constants';
import type { FunctionComponent, KeyboardEvent, Props } from './types';

import styles from './styles.module.scss';

const Accordion: FunctionComponent<Props> = ({
    children,
    className = '',
    isOpen,
    label,
    onToggle,
    testId = TEST_ID
}) => {
    const openClass = isOpen ? styles.open : '';

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        const { key } = event;

        if (![ENTER, SPACE].includes(key)) {
            return;
        }

        event.preventDefault();
        onToggle();
    };

    return (
        <VerticalContainer className={`${className} ${styles.accordion}`} testId={testId}>
            <Grid
                className={styles.grid}
                dataExpanded={isOpen}
                onClick={onToggle}
                onKeyDown={handleKeyDown}
                role='button'
                tabIndex={0}>
                <GridText className={styles.label} text={label} />

                <TriangleArrowIcon className={`${openClass} ${styles.triangleArrowIcon}`} />
            </Grid>

            <Wrapper className={`${openClass} ${styles.content}`}>{children}</Wrapper>
        </VerticalContainer>
    );
};

export default Accordion;
